<script setup>
	import { DsButton } from '@coloplast/design-system';
	import { ref, computed } from 'vue';

	const props = defineProps({
		references: {
			type: Array,
			default: () => [],
		},
		listType: {
			type: String,
		},
		vm: {
			type: Object,
			default: () => {},
		},
	});

	const marginStyle = computed(() => (props.listType === 'none' ? '0' : '14px'));
	const referenceItems = computed(() => props.references?.length ? props.references : props.vm.currentBlock?.items);
	const isFoldingEnabled = computed(() => props.vm?.currentBlock?.enableFolding === 'True');

	const isUnfolded = ref(false);

	const toggleFolding = () => {
		isUnfolded.value = !isUnfolded.value;
	}
</script>

<template>
	<div
		v-if="referenceItems.length"
		class="c-references-block__container"
	>
		<div class="c-references-block__wrapper">
			<ol
				class="c-references-block__list"
				:class="{ 'c-references-block__overlay' : isFoldingEnabled && !isUnfolded }"
				:style="`list-style-type:${listType}; margin-left: ${marginStyle}`"
			>
				<li
					v-for="(item, index) in referenceItems"
					:key="index"
					class="c-references-block__item"
				>
					<span
						v-if="item.referenceText"
						v-html="item.referenceText"
					>
					</span>
					<DsButton
						v-if="item.linkUrl"
						variant="link"
						size="sm"
						:href="item.linkUrl"
						target="_blank"
						class="c-references-block__link"
					>
						{{ item.linkLabel || item.linkUrl }}
					</DsButton>
				</li>
			</ol>
			<div
				v-if="isFoldingEnabled"
				class="c-references-block__button-fold"
			>
				<DsButton
					v-if="!isUnfolded && vm.currentBlock.viewMoreText"
					type="button"
					variant="link-neutral"
					size="sm"
					icon-end="navigate-down"
					:click-handler="toggleFolding"
				>
					{{ vm.currentBlock.viewMoreText }}
				</DsButton>
				<DsButton
					v-if="isUnfolded && vm.currentBlock.viewLessText"
					type="button"
					variant="link-neutral"
					size="sm"
					icon-end="navigate-up"
					:click-handler="toggleFolding"
				>
					{{ vm.currentBlock.viewLessText }}
				</DsButton>
			</div>
		</div>
	</div>
</template>
